import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = definePartsStyle({
	list: {
		background: "primary-accent.500",
		border: "none",
		boxShadow: "md",
		zIndex: 50,
	},
	item: {
		background: "primary-accent.500",
		_hover: {
			background: "primary-accent.600",
		},
		_active: {
			background: "primary-accent.700",
		},
	},
	divider: {
		borderColor: "primary.1000",
	},
});

export const Menu = defineMultiStyleConfig({ baseStyle });
